module.exports = __webpack_public_path__ + "static/media/DNDResized.e9cf63e0.png";